import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setProgress, setToast } from "../../../redux/slice/system";
import { QaAPI } from "../../../axios/api";
import {
  useAbortedEffect,
  useSearch,
  useTable,
  useConfirm,
  usePop,
} from "../../../components/hooks";

import ModuleBreadCrumb from "../../../components/breadCrumb";
import ModulePopQAOrder from "./popOrder";
import {
  formatOptions,
  setPageSetting,
  formatNumber,
} from "../../../service/common";
import { system_dropdown, system_table } from "../../../service/system";

import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { classNames } from "primereact/utils";

export default function BackQaList() {
  const route_navigate = useNavigate();
  const dispatch = useDispatch();
  const crumbItem = [
    {
      key: 1,
      label: "QA管理",
    },
  ];
  const { isPop, popOption, openPop, closePop, renderDialog } = usePop([
    {
      key: "order",
      title: () => "排序",
      isOpen: false,
    },
  ]);
  const [reload, setReload] = useState({ list: false });
  const {
    setTbData,
    tbTotalRecords,
    setTbTotalRecords,
    setTbFirstIndex,
    setTbRows,
    setTbColumns,
    renderTable,
    setPageAction,
  } = useTable();
  // 篩選條件
  const defaultFilter = {
      page: 1,
      size: system_table.size,
      type: 1,
    },
    pagePath = "/qa";
  const {
    filterData,
    setFilterData,
    search,
    setSearch,
    changeFilter,
    renderSearchWrap,
  } = useSearch({
    defaultFilter,
    pagePath: [pagePath],
    tbSetting: { setTbFirstIndex, setTbRows },
    reloadAction: () => setReload((state) => ({ ...state, list: true })),
  });
  const { confirmOption, setConfirmOption, renderConfirm } = useConfirm();

  useEffect(() => {
    const action = ({ startIndex, rows }) => {
      let temp = {
        ...search,
        page: Math.floor(startIndex / rows) + 1,
        size: rows,
      };
      setFilterData(temp);
      setSearch(temp);
    };
    setPageAction(
      () =>
        ({ startIndex, rows }) =>
          action({ startIndex, rows })
    );
  }, [search]);

  // 取得列表資料
  useAbortedEffect(
    (signal) => {
      if (!reload.list) return;

      dispatch(setProgress(true));

      setPageSetting({ params: search, page: pagePath });

      let params = {
        ...search,
      };

      QaAPI.getQuestionAndAnswerList({
        data: params,
        options: { signal },
      }).then((result) => {
        let { Response, data, total, message } = result;

        if (Response === 1) {
          setTbData(data);
          setTbTotalRecords(total);
          setReload((state) => ({
            ...state,
            list: false,
          }));
        } else {
          dispatch(
            setToast({
              severity: "error",
              summary: message,
              detail: "",
            })
          );
        }

        dispatch(setProgress(false));
      });
    },
    [reload]
  );

  useEffect(() => {
    setTbColumns([
      {
        field: "question",
        header: "問題(Q)",
        className: "flex-grow-1 w-8rem",
      },
      {
        field: "answer",
        header: "答案(A)",
        className: "flex-grow-1 w-20rem white-space-prewrap",
      },
      {
        field: "target",
        header: "進階",
        className: "w-9rem",
        body: (data) => (
          <>
            <Button
              className="p-button-warning p-button-sm mr-2"
              type="button"
              label="編輯"
              onClick={() => route_navigate(`/back${pagePath}/${data.id}`)}
            />
            <Button
              id={`button_delete_${data.id}`}
              className="p-button-danger p-button-sm mr-2"
              type="button"
              label="刪除"
              onClick={() =>
                setConfirmOption({
                  setting: {
                    target: document.getElementById(`button_delete_${data.id}`),
                    message: "確認是否刪除?",
                    icon: "pi pi-exclamation-triangle",
                    visible: !confirmOption.setting.visible,
                    acceptLabel: "是",
                    rejectLabel: "否",
                    accept: () => deleteAction({ data }),
                    reject: () => null,
                  },
                  reOpen: confirmOption.setting.visible,
                })
              }
            />
          </>
        ),
      },
    ]);
  }, [pagePath]);

  const deleteAction = ({ data }) => {
    dispatch(setProgress(true));

    let jsonData = { id: data.id };

    QaAPI.deleteQuestionAndAnswer({ data: jsonData }).then((result) => {
      let { Response } = result;

      if (Response === 1) {
        dispatch(
          setToast({
            severity: "success",
            summary: "成功刪除",
            detail: "",
          })
        );
        setReload((state) => ({
          ...state,
          list: true,
        }));
      } else {
        dispatch(
          setToast({
            severity: "error",
            summary: "刪除失敗",
            detail: "",
          })
        );
        dispatch(setProgress(false));
      }
    });
  };

  return (
    <>
      {renderConfirm}

      <ModuleBreadCrumb crumbItem={crumbItem} />

      <h2 className="my-3 ml-1">QA管理</h2>

      <div className="border-round-lg bg-white p-3">
        {/* {renderSearchWrap({
          isShow: true,
          template: (
            <>
              <div className="col-12 md:col-4 xl:col-3 flex align-items-start flex-column mt-2 md:mt-0">
                <label
                  htmlFor="username"
                  className="w-4rem white-space-nowrap text-left mb-1"
                >
                  類型
                </label>
                <Dropdown
                  name="type"
                  className="w-full"
                  value={filterData.type}
                  onChange={(e) => changeFilter(e)}
                  options={[]}
                  emptyMessage={system_dropdown.empty}
                  showClear={false}
                />
              </div>
              <div
                className={classNames(
                  "col-12 md:col-8 xl:col-9 flex align-items-end mt-2 md:mt-0"
                )}
              >
                <Button
                  className="p-button-info w-auto ml-auto md:ml-0 md:mt-0 px-3"
                  type="button"
                  icon="pi pi-search"
                  label="查詢"
                  onClick={() => {
                    setSearch({
                      ...filterData,
                      page: 1,
                    });
                    setTbFirstIndex(0);
                  }}
                />

                <Button
                  className="w-auto md:ml-auto ml-3 px-3"
                  type="button"
                  label="新增"
                  onClick={() => route_navigate(`/back${pagePath}/add`)}
                />
              </div>
            </>
          ),
        })} */}

        <div className="flex mb-2">
          <Button
            className="p-button-warning w-auto md:ml-auto ml-2 px-3"
            type="button"
            label="排序"
            onClick={() => openPop({ type: "order" })}
          />
          <Button
            className="w-auto ml-2 px-3"
            type="button"
            label="新增"
            onClick={() => route_navigate(`/back${pagePath}/add`)}
          />
        </div>

        {renderTable({
          className: "mt-2",
          isLazy: false,
          options: { scrollable: true, scrollDirection: "both" },
        })}
      </div>

      {renderDialog({
        className: "w-11 md:w-10 lg:w-8 max-w-30rem",
        children: (
          <>
            {isPop.order?.isOpen && (
              <ModulePopQAOrder
                prePopOption={popOption}
                closePrePop={closePop}
                setPreReload={setReload}
              />
            )}
          </>
        ),
      })}
    </>
  );
}
